/**
 * 帮助中心
 */
export default [
  {
    path: '/help/index',
    component: () => import('@/views/user/help/Index'),
    meta: {
      scrollToTop: true,
      layout: {
        pageWrap: false
      }
    }
  },
  {
    path: '/help/search',
    component: () => import('@/views/user/help/Search'),
    meta: {
      scrollToTop: true,
      layout: {
        pageWrap: false
      }
    }
  }
]
